import { Button, styled } from "@mui/material";

const StyledSearchCuil = {
  SearchContainer: styled("div")(({ theme }) => ({
    padding: 35,
    display: "flex",
    alignItems: "center",
    gap: 10
  })),
  Button: styled(Button)(({ theme }) => ({
    margin: 10,
  })),
};

export default StyledSearchCuil;
